import styled from 'styled-components';
import bgRaster from 'assets/Images/bgRaster.png';

export const Canvas = styled.canvas`
  position: absolute;
  backface-visibility: hidden;
  background-image: url(${bgRaster});
  left: 0;
  top: 0;
`;